export type LanderDatasetID = 'net-impact' | 'sdgs' | 'eu-taxonomy' | 'sfdr-pai' | 'csrd';

interface NavMenuDatasetItem {
  id: LanderDatasetID;
  linkText: string;
  url: string;
}

/* Kept exported because it is still consumed by the mobile burger menu's
   DataBlock (`mobile-header/burger-menu/data-block/index.tsx`). The
   desktop NavMenu no longer renders dataset links — that section was
   removed when the Products menu was replaced with Solutions. */
export const navMenuDatasetItems: NavMenuDatasetItem[] = [
  {
    id: 'net-impact',
    linkText: 'Net impact',
    url: 'https://www.uprightproject.com/products/datasets/#net-impact',
  },
  {
    id: 'sdgs',
    linkText: 'UN SDG alignment',
    url: 'https://www.uprightproject.com/products/un-sdg-revenue-alignment/',
  },
  {
    id: 'eu-taxonomy',
    linkText: 'EU taxonomy',
    url: 'https://www.uprightproject.com/products/datasets/#eu-taxonomy',
  },
  {
    id: 'sfdr-pai',
    linkText: 'EU SFDR PAI',
    url: 'https://www.uprightproject.com/products/datasets/#sfdr-pai',
  },
  {
    id: 'csrd',
    linkText: 'CSRD & double materiality',
    url: 'https://www.uprightproject.com/products/csrd-double-materiality-assessment/',
  },
];

export interface SolutionsMenuItem {
  linkText: string;
  url: string;
}

export interface SolutionsMenuGroup {
  heading: SolutionsMenuItem;
  items: SolutionsMenuItem[];
}

/* "Solutions" menu groups, mirrored from upright-facade's
   `src/facade/src/new-lander-page/nav.tsx` (`SOLUTIONS_COLUMNS`). Each
   audience heading is itself a link (the facade renders it as a labelled
   audience chip); product picks below it are individual links.

   Facade-internal paths are rewritten as absolute www.uprightproject.com
   URLs because the platform header opens these in a new tab — the
   platform itself does not render the marketing routes. */
export const solutionsMenuGroups: SolutionsMenuGroup[] = [
  {
    heading: { linkText: 'For investors', url: 'https://www.uprightproject.com/products/investors/' },
    items: [
      { linkText: 'Private equity', url: 'https://www.uprightproject.com/products/private-equity/' },
      { linkText: 'Private credit', url: 'https://www.uprightproject.com/private-credit/' },
      { linkText: 'Asset managers', url: 'https://www.uprightproject.com/products/asset-managers/' },
      { linkText: 'Asset owners', url: 'https://www.uprightproject.com/products/asset-owners/' },
      {
        linkText: 'Impact quantification',
        url: 'https://www.uprightproject.com/products/investors-impact-quantification',
      },
      {
        linkText: 'LP & regulatory reporting',
        url: 'https://www.uprightproject.com/products/investors-regulatory-reporting',
      },
      { linkText: 'ESG due diligence', url: 'https://www.uprightproject.com/products/due-diligence' },
      { linkText: 'Regulatory proxy data', url: 'https://www.uprightproject.com/products/regulatory-proxies' },
    ],
  },
  {
    heading: { linkText: 'For companies', url: 'https://www.uprightproject.com/products/companies/' },
    items: [
      { linkText: 'Double materiality assessment', url: 'https://www.uprightproject.com/products/dma' },
      {
        linkText: 'Financial quantification of sustainability',
        url: 'https://www.uprightproject.com/financial-effects',
      },
      { linkText: 'Climate risk assessment', url: 'https://www.uprightproject.com/products/climate-risk-assessment' },
      {
        linkText: 'Impact quantification & communications',
        url: 'https://www.uprightproject.com/impact-communications',
      },
    ],
  },
  {
    heading: {
      linkText: 'For advisors',
      url: 'https://www.uprightproject.com/products/double-materiality-assessment-consultants/',
    },
    items: [],
  },
  {
    heading: { linkText: 'For universities', url: 'https://www.uprightproject.com/products/universities/' },
    items: [],
  },
];
